import React from "react";

import Messages from "../../messages";

const renderQuarter = (quarter) =>
  quarter && (
    <li>
      <strong itemProp="location" itemScope itemType="https://schema.org/Place">
        <a href={quarter.url} rel="external" itemProp="url">
          <span itemProp="name">{quarter.name}</span>
        </a>
      </strong>
    </li>
  );

const renderStation = (station) =>
  station && (
    <li>
      {Messages.transportKinds[station.kind]} <strong>{station.name}</strong>
    </li>
  );

const renderDistrict = ({ name, url }) => {
  if (!name.length) {
    return null;
  }

  const number = name[1];
  let sup;
  let abbr;

  if (name[2]) {
    sup = <sup>{name[2]}</sup>;
    abbr = " arrdt.";
  }

  return (
    <li>
      <a href={url} rel="external">
        {number}
        {sup}
        {abbr}
      </a>
    </li>
  );
};

const HotelGeo = ({ hotel }) => (
  <ul className="geo">
    {renderQuarter(hotel.quarter)}
    {renderDistrict(hotel.district)}
    {renderStation(hotel.station)}
    <li>
      <a href={`${hotel.url}#map`} rel="external" itemProp="hasMap">
        voir la carte
      </a>
    </li>
  </ul>
);

export default HotelGeo;
